<template>
    <div class="sites-container" :style="{height: `${totalHeight}px`}">
        
        <div class="site" v-for="(site, index) in $props.sites" @click="$emit('site-click', site, 0, null)">

            <div class="site-checkbox-container">
                <v-simple-checkbox color="#c42111" :value="allSiteSectorsSelected(site)" @input="selectAllSites(site)" :ripple="false" :disabled="!(site.sectors && site.sectors.length)" />
            </div>

            <div class="text-container">
                <span class="name" v-text="site.name" />
                <span class="office" v-text="`${site.office}/${site.location}`" />
            </div>
            <div class="alarm-section" :class="{'first': index === 0}">
                <div class="alarm-container">
                    <v-icon :color="criticalColor.background" >mdi-bell</v-icon>
                    <div class="count-container">
                        <span class="count" :style="{color: criticalColor.foreground}" v-text="site.alarms.filter(a => a.alarm_severity == 'CRITICAL').length" />
                    </div>
                </div>
                <div class="alarm-container">
                    <v-icon :color="majorColor.background" >mdi-bell</v-icon>
                    <div class="count-container">
                        <span class="count" :style="{color: majorColor.foreground}" v-text="site.alarms.filter(a => a.alarm_severity == 'MAJOR').length" />
                    </div>
                </div>
                <div class="alarm-container">
                    <v-icon :color="minorColor.background" >mdi-bell</v-icon>
                    <div class="count-container">
                        <span class="count" :style="{color: minorColor.foreground}" v-text="site.alarms.filter(a => a.alarm_severity == 'MINOR').length" />
                    </div>
                </div>
                <div class="alarm-container">
                    <v-icon :color="observationalColor.background" >mdi-bell</v-icon>
                    <div class="count-container">
                        <span class="count" :style="{color: observationalColor.foreground}" v-text="site.alarms.filter(a => a.alarm_severity == 'OBSERVATIONAL').length" />
                    </div>
                </div>
            </div>

            <div class="sectors-section" v-if="site.sectors && site.sectors.length">
                <div class="sector-container"  v-for="(sector, index) in site.sectors">
                    <div class="checkbox-container">
                        <v-simple-checkbox color="#c42111" v-model="sector.draw_polygons" :ripple="false" @input="$emit('redrawPolygons', [site])" />
                    </div>
                    <div class="sector-text">
                        <span class="sector-name">{{ sector.sect_name }}</span>
                        <span class="sector-mscid">{{ sector.sect_mscid }}</span>
                    </div>
                    <div class="sector-azimuth-text">
                        <span>{{ sector.azimuth }}</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'MapItemContextWindow',
    props: ['infoWindowElementCtr', 'map', 'mapItem', 'sites'],
    components: {

    },
    data: () => ({
        mapItemContextWindow: null,
        contextWindowOptions: {
            pixelOffset: {width: 0, height: -5},
        },
    }),

    computed: {
        criticalColor() {
            return this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.critical;
        },
        majorColor() {
            return this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.major;
        },
        minorColor() {
            return this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.minor;
        },
        observationalColor() {
            return this.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical.observational;
        },

        totalHeight() {
            let sites = this.$props.sites;
            let height = 0;
            for(let site of sites) {
                height += 45;
                height += site.sectors ? (site.sectors.length * 36) : 0;
            }
            return height;
        }
    },

    methods: {
        allSiteSectorsSelected: function(site) {
            if(!(site.sectors && site.sectors.length)) {
                return false;
            }
            return site.sectors.every(sect => sect.draw_polygons);
        },

        selectAllSites: function(site) {
            if(site.sectors.every(sect => sect.draw_polygons)) {
                site.sectors.forEach(sect => {sect.draw_polygons = false});
            }
            else {
                site.sectors.forEach(sect => {sect.draw_polygons = true});
            }
            this.$emit('redrawPolygons', this.$props.sites);
        }
    },

    watch: {
        'mapItem.position': {
            handler(newVal, oldVal) {
                this.mapItemContextWindow.setPosition(this.$props.mapItem.position);
            },
        }
    },

    mounted() {
        this.mapItemContextWindow.setPosition(this.$props.mapItem.position);
        this.mapItemContextWindow.setContent(this.$el);
        this.mapItemContextWindow.open({map: this.$props.map});
    },

    created() {
        this.mapItemContextWindow = new this.$props.infoWindowElementCtr(this.contextWindowOptions);
        this.mapItemContextWindow.addListener('close', () => {
            this.$emit('close');
        });
    },

    destroyed() {
        this.mapItemContextWindow.close();
    }

  
};
</script>

<style scoped>

    .sites-container {
        max-height: 400px;
        max-width: 460px;
        width: 460px;
        overflow-y: auto;
    }

    .site {
        color: #000000;
        width: 100%;
        background-color: #F0F0F0;
        position: relative;
        cursor: pointer;
        border-bottom: solid #000000 1px;
        padding: 5px;
    }
    .site:last-child {
        border-bottom: none;
    }
    .site:hover {
        background-color: #D3D3D3;
    }

    .site .site-checkbox-container {
        display: inline-block;
        width: 30px;
        vertical-align: super;
    }

    .site .text-container {
        display: inline-block;
    }

    .site .name {
        display: block;
        font-size: 18px;
        font-weight: bold;
    }

    .site .office {
        display: block;
        font-size: 12px;
    }

    .site .alarm-section {
        display: block;
        position: absolute;
        top: 5px;
        right: 10px;
    }
    .site .alarm-section.first {
        right: 30px;
    }

    .site .alarm-container {
        display: inline-block;
        position: relative;
    }

    .site .alarm-container .count-container {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 6px;
        font-size: 11px;
        font-weight: bold;
        color: #ffffff;
    }

    .sectors-section {
        display: block;
    }

    .sectors-section .sector-container {
        display: block;
        padding-left: 0px;
        height: 35px;
        border-top: #000000 solid 1px;
    }

    .sectors-section .sector-container .checkbox-container {
        display: inline-block;
        width: 30px;
        height: calc(100% - 5px);
    }

    .sectors-section .sector-container .sector-text {
        display: inline-block;
        width: 360px;
        padding-top: 3px;
    }
    .sectors-section .sector-container .sector-text .sector-name {
        font-size: 12px;
        display: block;
    }
    .sectors-section .sector-container .sector-text .sector-mscid {
        font-size: 12px;
        display: block;
    }

    .sectors-section .sector-container .sector-azimuth-text {
        display: inline-block;
        text-align: right;
        width: 45px;
    }
    .sectors-section .sector-container .sector-azimuth-text span {
        font-size: 24px;
        font-weight: 400;
    }

</style>

<style>

    .gm-style .gm-style-iw-c {
        padding: 0px;
    }

    .gm-style .gm-style-iw-d {
        overflow: hidden !important;
    }

</style>
